export const NavigationDirections = {
    FORWARD: "forward",
    BACKWARD: "backward"
}
